import type { ThemeConfig } from 'antd';

export const theme: ThemeConfig = {
	token: {
		fontFamily: 'Chakra Petch',
	},
	components: {
		Button: {},
		Collapse: {
			headerBg: 'transparent',
		},
	},
};
